import { Box, Collapse, Flex, Text } from "@chakra-ui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import { useState } from "react";
import { EndpointGroup } from "./types";
import { EndpointRow } from "./EndpointRow";

export function EndpointGroupSection({ group }: { group: EndpointGroup }) {
  const [open, setOpen] = useState(true);

  return (
    <Box mt="16px">
      {/* Group header */}
      <Flex
        align="center"
        gap="10px"
        cursor="pointer"
        onClick={() => setOpen((v) => !v)}
        userSelect="none"
        mb="8px"
      >
        <Text fontWeight="700" fontSize="16px" color="#1E293B">
          {group.tag}
        </Text>
        {group.description && (
          <Text fontSize="13px" color="gray.400" fontWeight="400">
            {group.description}
          </Text>
        )}
        <Box ml="auto" color="gray.400">
          {open ? (
            <ChevronUpIcon boxSize="16px" />
          ) : (
            <ChevronDownIcon boxSize="16px" />
          )}
        </Box>
      </Flex>

      <Collapse in={open} animateOpacity>
        <Box
          border="1px solid"
          borderColor="gray.200"
          borderRadius="10px"
          overflow="hidden"
        >
          {group.endpoints.map((ep, i) => (
            <EndpointRow key={`${ep.method}-${ep.path}-${i}`} endpoint={ep} />
          ))}
        </Box>
      </Collapse>
    </Box>
  );
}
